<template>
    <div id="nav">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              Fund Balances
            </v-list-item-title>
            <v-list-item-subtitle>
              <br />
                <v-img src="../assets/background/piggybank.jpg"></v-img>
              <br />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
  
        <v-list
          dense
          nav
        >
          <v-list-item
            v-for="item in items"
            :key="item.title"
            link :to="item.path"
          >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title 
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
            </template>
            <span>{{ item.tooltipText}}</span>
          </v-tooltip>
            
          </v-list-item>
        </v-list>
    </div>
</template>


<script>
export default {
    name: "navigation",
    data() {
        return {
            items: [
              /*
                { 
                  title: "Home", 
                  icon: "mdi-home", 
                  path: "/home", 
                  tooltipText: "Home Page" 
                },
              */
                { 
                  title: "Fund Balances", 
                  icon: "mdi-finance", 
                  path: "/financialanalysis",
                  tooltipText: "View Fund Balances",
                  color: "#01579B"
                },
                {
                  title: "Search",
                  icon: "mdi-archive-search",
                  path: "/searchdata",
                  tooltipText: "View searched user data (For ITS only)",
                  color: "#1B5E20"
                },
                {
                  title: "Upload",
                  icon: "mdi-file-upload",
                  path: "/uploadcsv",
                  tooltipText: "Upload CSV File (For ITS only)",
                  color: "#FD49A0"
                }
            ],
            right: null
        };
    }
}
</script>